<template>
  <div class="top">
    <div class="site-nav">
      <div class="content">
        <div class="site-nav-l">
          <ul>
            <li><router-link to="/" title="万杰官网">万杰官网</router-link></li>
            <li>
              <router-link to="/case" title="成功案例">成功案例</router-link>
            </li>
            <!-- <li><router-link to="/" title="合作伙伴">合作伙伴</router-link></li> -->
            <li>
              <router-link to="/case/customer" title="客户案例">客户案例</router-link>
            </li>
            <li>
              <router-link to="/about/problem" title="常见问题">常见问题</router-link>
            </li>
            <li>
              <router-link to="/about/album" title="企业相册">企业相册</router-link>
            </li>
            <li>
              <router-link to="/about" title="关于万杰">关于万杰</router-link>
            </li>
            <li>
              <router-link to="/about/contanct" title="联系万杰">联系万杰</router-link>
            </li>
            <li>
              <router-link to="/news/xydt" title="行业动态">行业动态</router-link>
            </li>
          </ul>
        </div>
        <div class="site-nav-r">
          <a href="https://wanjiepai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.456a689aKx0Vgm" target="_blank" class="shop">天猫店铺</a>
          <a href="https://wanjiepai.tmall.com/index.htm?spm=a1z10.1-b.w5002-21892435601.2.392d4b19u5rBHF" target="_blank" class="shop">淘宝店铺</a>
          <a href="https://wanjiezhineng.1688.com/?spm=a261y.7663282.autotrace-common_topbar.1.7e203851QuVc3O" target="_blank" class="shop">阿里店铺</a>
          <a href="https://mall.jd.com/index-791402.html?from=pc" target="_blank" class="shop">京东店铺</a>
          <span class="ewm" @mouseover="wximg = true" @mouseleave="wximg = false">万杰公众号</span>
        </div>
        <div class="wx-img" v-if="wximg">
          <img src="@img/ma2.jpg" alt="河南万杰智能科技股份" title="河南万杰智能科技股份" />
        </div>
      </div>
    </div>

    <div class="header pr">
      <div class="h_con">
        <div class="h_dw">
          <router-link to="/"><img src="@img/head-logo.png" alt="河南万杰智能科技股份" title="河南万杰智能科技股份" /></router-link>
          <div class="title">
            <!-- <p>145项自主知识产权</p>
            <p>{{year}}年专注食品机械研发生产</p> -->
          </div>
        </div>
        <p class="tel"><i>400-677-1996</i></p>
      </div>
      <div class="h_nav menu">
        <ul>
          <li>
            <router-link to="/" :class="path == 'index' ? 'cur' : ''">首页</router-link>
          </li>
          <li>
            <router-link to="/products/mtjjymj" :class="parms == 'mtjjymj' ? 'cur' : ''">面条机</router-link>
          </li>
          <li>
            <router-link to="/products/qzdmtj" :class="parms == 'qzdmtj' ? 'cur' : ''">馒头机</router-link>
          </li>
          <li>
            <router-link to="/products/qzdbzj" :class="parms == 'qzdbzj' ? 'cur' : ''">包子机</router-link>
          </li>
          <li>
            <router-link to="/products/qzdjzj" :class="parms == 'qzdjzj' ? 'cur' : ''">饺子机</router-link>
          </li>
          <li class="nav_li05">
            <h1 class="logo">
              <router-link to="/"><img alt="河南万杰智能科技股份" src="@img/logo.png" title="河南万杰智能科技股份" /></router-link>
            </h1>
          </li>
          <li>
            <router-link to="/products/hmj" :class="parms == 'hmj' ? 'cur' : ''">和面机</router-link>
          </li>
          <li>
            <router-link to="/products/qcjjjqj" :class="parms == 'qcjjjqj' ? 'cur' : ''">切菜机</router-link>
          </li>
          <li>
            <router-link to="/products/all" :class="proClass">产品展示</router-link>
          </li>
          <li>
            <router-link to="/case/customer" :class="path == 'customer' ? 'cur' : ''">客户案例</router-link>
          </li>
          <!-- <li><router-link to="/about" :class="path == 'about' ? 'cur' : ''">关于万杰</router-link></li>
          <li><router-link to="/news/all" :class="path == 'news' ? '' : ''">新闻动态</router-link></li> -->
          <li>
            <router-link to="/about/contanct" :class="path == 'contanct' ? 'cur' : ''">联系我们</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: null,
      parms: null,
      // this.$route.params.name || this.$route.params.type
      productActive: null,
      wximg: false,
      year: new Date().getFullYear() - 1996,
    };
  },
  mounted() {
    this.path = this.$route.meta.intro;
    this.parms = this.$route.params.name || this.$route.params.type;
  },
  watch: {
    $route: function () {
      this.path = this.$route.meta.intro;
      this.parms = this.$route.params.name || this.$route.params.type;
    },
  },
  computed: {
    proClass() {
      if (this.path == 'products') {
        if (this.parms != 'qzdjzj' && this.parms != 'mtjjymj' && this.parms != 'qzdmtj' && this.parms != 'hmj' && this.parms != 'qcjjjqj' && this.parms != 'qzdbzj') {
          return 'cur';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="less">
.top {
  min-width: 1200px;
  width: 100%;
  position: relative;
  z-index: 10;
  .site-nav {
    background-color: #333333;
    .content {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #b0b0b0;
      position: relative;
      .wx-img {
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 10;
        img {
          width: 110px;
        }
      }
      ul {
        display: flex;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #b0b0b0;

        li {
          padding: 0 5px;
          position: relative;

          &:not(:last-child)::after {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -5px;
            height: 10px;
            width: 1px;
            /*no*/
            background: rgba(176, 176, 176, 0.22);
          }
          a {
            color: #b0b0b0;

            &:hover {
              color: rgba(255, 255, 255, 1);
            }
          }
        }
      }

      .shop,
      .ewm {
        padding: 0 10px;
        color: rgba(176, 176, 176, 1);
        cursor: pointer;
        position: relative;

        &:hover {
          text-decoration: underline;
          color: rgba(255, 255, 255, 1);
        }
      }

      .shop:after {
        content: '';
        position: absolute;
        right: -0.5px;
        top: 50%;
        margin-top: -5px;
        height: 10px;
        width: 1px;
        /*no*/
        background: rgba(176, 176, 176, 0.22);
      }
    }
  }

  .h_con {
    height: 50px;
    margin: 30px 0;
    overflow: hidden;
    .h_dw {
      float: left;
      line-height: 30px;
      // width: 398px;
      font-weight: bold;
      font-size: 21px;
      color: #186060;
      padding: 10px 18px;
      display: flex;
      align-items: flex-end;
      img {
        width: 156px;
        height: 34px;
      }
      .title {
        font-size: 12px;
        line-height: 17px;
        color: #666666;
        margin-left: 10px;
        padding-bottom: 5px;
        font-weight: normal;
      }
    }
    .tel {
      float: right;
      font-size: 14px;
      color: #666;
      background: url(~@img/tel.jpg) no-repeat 0 center;
      padding: 0 0 0 55px;
      line-height: 42px;
      i {
        font-size: 32px;
        font-weight: bold;
        display: block;
        color: rgba(19, 181, 179, 1);
      }
    }
  }
  .h_nav {
    height: 50px;
    li {
      position: relative;
      height: 50px;
      line-height: 50px;
      float: left;
      position: relative;
      &:not(:last-child):after {
        content: '';
        position: absolute;
        right: 0;
        top: 36%;
        height: 11px;
        width: 1px;
        background: rgba(193, 193, 193, 1);
      }
      &.nav_li05 {
        width: 256px;
      }
      a {
        font-size: 16px;
        color: rgba(102, 102, 102, 1);
        // padding: 0 20px;
        padding: 0 21.5px;
        display: block;
        float: left;
      }

      .logo {
        height: 176px;
        position: absolute;
        bottom: -30px;
        left: 20px;
        img {
          width: 176px;
          height: 176px;
          display: block;
          // background: #ffffff;
          border-radius: 50%;
          // box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
        }
      }
    }
    li:not(.nav_li05) a:hover,
    li:not(.nav_li05) a.cur {
      font-weight: bold;
      color: rgba(19, 181, 179, 1);
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        background-color: rgba(19, 181, 179, 1);
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/head.vue